import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, pure } from 'recompose'
import { connect } from 'react-redux'
import styles from './styles.scss'

import { Card } from 'react-toolbox/lib/card'

import Fields from './Fields'

import {
    onSelectDisplayFilter,
    onRemoveDisplayFilter,
    onSaveClick,
    toggleSearchSectionCollapse,
    onDeselectAllSearchFilters,
    selectAllSearchFilters,
    expandAllFilters,
    collapseAllFilters,
    selectAllSearchSection
  } from 'containers/Project/ElasticSearch/actions'
  
import {
    searchFieldsSelector,
    isSearchSectionCollapse,
    noneCheckedSelector,
    searchFilterFormElementsSelector,
    collapsedSelector
} from 'containers/Project/ElasticSearch/selectors'


const PureFields = pure(Fields)

const mapStateToProps = (state) => {
    return {
        searchFields: searchFieldsSelector(state),
        noneChecked: noneCheckedSelector(state),
        isSectionCollapsed: state.project.search.collapsedSearchSections,
        searchFieldList: searchFilterFormElementsSelector(state),
        collapsedSections: collapsedSelector(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSave: () => dispatch(onSaveClick()),
        onSelect: (value) => dispatch(onSelectDisplayFilter(value)),
        onRemove: (value) => dispatch(onRemoveDisplayFilter(value)),
        toggleSectionCollapse: (idx) => dispatch(toggleSearchSectionCollapse(idx)),
        onDeselectAllSearchFilters: () => dispatch(onDeselectAllSearchFilters()),
        selectAllSearchFilters: (filters) => dispatch(selectAllSearchFilters(filters)),
        expandAllFilters: (length) => dispatch(expandAllFilters(length)),
        collapseAllFilters: () => dispatch(collapseAllFilters()),
        selectAllSearchSection: (idx) => dispatch(selectAllSearchSection(idx))
    }
}


const SearchFieldsCard = (props) => {
    const {
        onSelect,
        onRemove,
        onSave,
        searchFields,
        toggleSectionCollapse,
        isSectionCollapsed,
        onDeselectAllSearchFilters,
        noneChecked,
        selectAllSearchFilters,
        searchFieldList,
        collapsedSections,
        expandAllFilters,
        collapseAllFilters,
        selectAllSearchSection
      } = props
    return (
        <Card
            theme={styles}
        >
            <PureFields
                list={searchFields}
                onClick={(checked, value) => { 
                    checked ? onSelect(value) : onRemove(value)
                    onSave()
                }}
                theme={styles}
                toggleSectionCollapse={toggleSectionCollapse}
                isSectionCollapsed={isSectionCollapsed}
                onDeselectAllSearchFilters={onDeselectAllSearchFilters}
                selectAllSearchFilters={selectAllSearchFilters}
                noneChecked={noneChecked}
                searchFieldList={searchFieldList}
                expandAllFilters={expandAllFilters}
                collapseAllFilters={collapseAllFilters}
                collapsedSections={collapsedSections}
                selectAllSearchSection={selectAllSearchSection}
            />
        </Card>
    )
}




const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose (
    withConnect,
    withStyles
)
export default enhance(SearchFieldsCard);